export default `
-- CreateTable
CREATE TABLE "Attribute" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "parent_type" TEXT NOT NULL,
    "parent_id" TEXT NOT NULL,
    "name" TEXT NOT NULL,
    "value" TEXT NOT NULL,
    "workspace_id" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "updated_at" DATETIME NOT NULL,
    CONSTRAINT "Attribute_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);

-- CreateIndex
CREATE INDEX "Attribute_parent_type_idx" ON "Attribute"("parent_type");

-- CreateIndex
CREATE INDEX "Attribute_parent_id_idx" ON "Attribute"("parent_id");

-- CreateIndex
CREATE INDEX "Attribute_name_idx" ON "Attribute"("name");

-- CreateIndex
CREATE INDEX "Attribute_workspace_id_idx" ON "Attribute"("workspace_id");

-- CreateIndex
CREATE INDEX "Attribute_created_by_idx" ON "Attribute"("created_by");

-- CreateIndex
CREATE INDEX "Attribute_created_at_idx" ON "Attribute"("created_at");

-- CreateIndex
CREATE INDEX "Attribute_updated_at_idx" ON "Attribute"("updated_at");
`;
